<div
  class="card mb-4 position-relative cursor-pointer text-start animate__animated animate__fadeIn"
  role="button"
  tabindex="0"
  (click)="gotoSpaceDetails(space.uuid)"
  (keydown.enter)="gotoSpaceDetails(space.uuid)"
  (keydown.space)="$event.preventDefault(); gotoSpaceDetails(space.uuid)"
  [attr.aria-label]="space.is_my_space ? ('my_space' | translate) : space.name"
  [attr.data-cy]="'med_space_' + space.name"
>
  <div class="card-body" [id]="'space_' + i">
    <h3 class="xs-title medium text-truncate me-3 mb-1">
      {{ space.is_my_space ? ("my_space" | translate | titlecase) : space.name }}
    </h3>
    <div class="hstack">
      <p class="s-body secondary-color m-0">{{ "records" | translate | titlecase }}:&nbsp;</p>
      <p class="s-body bold secondary-color m-0">{{ space.record_count || 0 }}&nbsp;</p>
      <p class="s-body secondary-color m-0">
        - {{ "last_update" | translate | titlecase }}: {{ space.updated_at | safeTimeago }}
      </p>
    </div>
    <div class="d-flex justify-content-between align-items-end pt-3">
      <!-- TAGS -->
      <div class="med_tags d-flex w-100" (click)="$event.stopPropagation()">
        <div
          ngbDropdown
          container="body"
          class="d-flex justify-content-start align-items-center w-100"
          (openChange)="onTagsDropdownOpen($event)"
        >
          <div ngbDropdownToggle class="med_tags-toggle d-flex flex-nowrap align-items-center" #tagsContainer>
            @for (tag of space.tags; track tag.uuid) {
              <span
                class="med_tag tag_element_list med_tag-sm sm-body me-2 text-truncate"
                [style.visibility]="$index >= tagsToShow ? 'hidden' : null"
                [style.position]="$index >= tagsToShow ? 'absolute' : null"
                [style.pointerEvents]="$index >= tagsToShow ? 'none' : null"
                [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
                #tagElement
                [matTooltip]="getTooltipText(tag.name, tagElement)"
                matTooltipPosition="above"
              >
                {{ tag.name }}
              </span>
            }
          </div>
          @if (hiddenTags > 0) {
            <span #tagElementNoFit ngbDropdownToggle class="med_tag med_tag-sm sm-body border text-truncate"
              >+{{ hiddenTags }}</span
            >
          } @else {
            <span ngbDropdownToggle class="med_tag med_tag-sm sm-body border px-2 d-flex align-items-center">
              <app-icon icon="tag" class="icon-xxs"></app-icon>
            </span>
          }

          <div ngbDropdownMenu class="med_tags-dropdown">
            <div
              class="med_tag-header med_tag-header-bg px-3 py-2 border-bottom d-flex justify-content-start align-items-center flex-wrap gap-2"
            >
              <div class="med_tags d-flex flex-row align-items-center flex-wrap gap-2">
                @for (tag of space.tags; track tag.uuid) {
                  <span
                    class="med_tag d-flex justify-content-start align-items-center gap-1"
                    [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
                    ><span
                      class="l-body text-truncate"
                      #tagSpan
                      [matTooltip]="getTooltipText(tag.name, tagSpan)"
                      matTooltipPosition="above"
                      >{{ tag.name }}</span
                    >
                    <button type="button" class="btn btn-clean p-0" (click)="onDeleteTagFromSpace(tag.uuid, space)">
                      <app-icon icon="xmark" class="icon-xs"></app-icon>
                    </button>
                  </span>
                }
                @if (space.tags && space.tags.length > 0) {
                  <input
                    type="text"
                    [(ngModel)]="filterCreateTagName"
                    class="med_tag-search med_elastic-search form-control border-0 p-0"
                    #filterTagAutofocus
                    maxlength="45"
                    (input)="onFilterInputResize($event)"
                    (keyup.enter)="addTagByEnter()"
                  />
                }
              </div>
              @if (!space.tags?.length) {
                <input
                  type="text"
                  [(ngModel)]="filterCreateTagName"
                  placeholder="{{ 'search_tag_or_create' | translate }}"
                  class="med_tag-search form-control border-0 p-0"
                  (keyup.enter)="addTagByEnter()"
                  #filterTagAutofocus
                />
              }
            </div>

            <div class="p-3">
              <div class="med_tags d-flex flex-column justify-content-start gap-1">
                @if (filterCreateTagName && getShowAddButton()) {
                  <button
                    type="button"
                    class="med_tag l-body border cursor-pointer m-0 text-truncate btn btn-clean text-start"
                    (click)="onAddTag(filterCreateTagName)"
                  >
                    {{ "add" | translate }} <span class="med_tag-highlight">"{{ filterCreateTagName }}"</span>
                  </button>
                }
                @for (tag of getNonAddedTagList(); track tag.uuid) {
                  <div
                    class="med_tag-list-item d-flex justify-content-between align-items-center position-relative"
                    role="button"
                    tabindex="0"
                    (click)="onAddTagToSpace(tag, space)"
                    (keydown.enter)="onAddTagToSpace(tag, space)"
                    (keydown.space)="$event.preventDefault(); onAddTagToSpace(tag, space)"
                  >
                    <span
                      class="med_tag l-body cursor-pointer text-truncate"
                      [ngStyle]="{ 'background-color': tag.color || 'var(--highlight-bg)' }"
                      #tagListItemSpan
                      [matTooltip]="getTooltipText(tag.name, tagListItemSpan)"
                      matTooltipPosition="above"
                      >{{ tag.name }}</span
                    >

                    <button
                      type="button"
                      class="btn btn-clean p-1 med_tag-options"
                      [ngbPopover]="pContent"
                      #p="ngbPopover"
                      triggers="manual"
                      placement="right"
                      container="body"
                      [popoverClass]="'med_tag-popover'"
                      (click)="$event.stopPropagation(); editSelectedTag(p, tag)"
                    >
                      <app-icon icon="ellipsis-vertical"></app-icon>
                    </button>
                  </div>
                }
                <ng-template #pContent let-pop="popover">
                  <div
                    class="med_tag-header med_tag-header-bg border-bottom px-3 py-2"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                  >
                    <input
                      class="form-control mb-1"
                      id="tagName"
                      type="text"
                      [(ngModel)]="selectedTagName"
                      (mousedown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation()"
                    />
                    <button
                      type="button"
                      class="btn brn-clean px-0 py-2"
                      (click)="openDeleteConfirmation(); $event.stopPropagation()"
                    >
                      <app-icon icon="trash-can" class="icon-active icon-xs"></app-icon>
                      <span class="secondary-color">{{ "delete_tag" | translate }}</span>
                    </button>
                  </div>
                  <div
                    class="p-3 d-flex flex-wrap gap-2"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                  >
                    @for (colorTag of tagColorList; track colorTag.colorCode) {
                      <div>
                        <input
                          type="radio"
                          class="med_color-radio"
                          name="radioTag"
                          [id]="'radioTag_' + colorTag.colorCode"
                          [value]="colorTag.colorCode"
                          [(ngModel)]="updateTagColor"
                          (mousedown)="$event.stopPropagation()"
                          (click)="$event.stopPropagation()"
                        />
                        <label
                          class="med_color-box"
                          [for]="'radioTag_' + colorTag.colorCode"
                          [ngStyle]="{ 'background-color': colorTag.colorCode }"
                          [ngClass]="updateTagColor === colorTag.colorCode ? 'med_selected-color' : ''"
                          (mousedown)="$event.stopPropagation()"
                          (click)="$event.stopPropagation()"
                        ></label>
                      </div>
                    }
                  </div>
                  <div class="px-3 pb-3" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                    <button
                      type="button"
                      class="btn btn-primary w-100"
                      (click)="onUpdateTag({ uuid: selectedTagId, name: selectedTagName, color: updateTagColor })"
                    >
                      {{ "save" | translate | titlecase }}
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- #TAGS -->

      <!-- SPACE USERS -->
      @if ((space.users?.length || 0) > 1) {
        <p-avatarGroup class="flex-shrink-0" [matMenuTriggerFor]="usersMenu" (click)="$event.stopPropagation()">
          @for (user of space.users | slice: 0 : 4; track user.email) {
            <div class="med_avatar position-relative">
              <p-avatar
                [style]="{ 'background-color': user.email | hexColor }"
                [style]="{ 'background-color': user.email | hexColor }"
                [label]="user | userInitials"
                shape="circle"
                class="med_user-circle avatar-border"
              />
              @if (user.role == "owner") {
                <div
                  class="med_owner position-absolute d-flex justify-content-center align-items-center rounded-circle top-0 start-0"
                >
                  <app-icon icon="star" class="med_light-icon" />
                </div>
              }
            </div>
          }
          @if ((space.users?.length || 0) > 4) {
            <div class="med_avatar position-relative">
              <p-avatar
                label="+{{ (space.users?.length || 0) - 4 }}"
                shape="circle"
                class="med_user-circle med_view-users"
              />
            </div>
          }
        </p-avatarGroup>

        <mat-menu #usersMenu="matMenu">
          <div class="med_users-list-wrapper text-start d-flex flex-column gap-2">
            @for (user of space.users; track user.email) {
              <div class="med_user-item d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-start align-items-center gap-2 position-relative">
                  <p-avatar
                    [label]="user | userInitials"
                    shape="circle"
                    class="med_user-circle avatar-border"
                    [style]="{ 'background-color': user.email | hexColor }"
                  />
                  <p class="xxl-body text-truncate">
                    {{ user.first_name + " " + user.last_name }}
                    @if (user.role == "owner") {
                      <span class="l-body text-truncate secondary-color fst-italic">{{ "owner" | translate }}</span>
                    }
                  </p>
                  @if (user.role == "owner") {
                    <div
                      class="med_owner position-absolute d-flex justify-content-center align-items-center rounded-circle top-0 start-0"
                    >
                      <app-icon icon="star" class="med_light-icon" />
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </mat-menu>
      }
    </div>
  </div>
  <div class="action-buttons-wrapper position-absolute top-0 end-0 mt-2 d-flex align-items-center">
    @if (space.is_archived && space.role === "owner") {
      <button
        class="icon-action-button"
        (click)="onOpenUnarchivePrompt(space, $event)"
        *spaceUserCanDo="space.role; action: 'space_unarchive'"
      >
        <app-icon icon="unarchive" class="cursor-pointer" />
      </button>
    }
    @if (space.role == "owner") {
      <mat-icon-button
        class="three-dots-vetical"
        [matMenuTriggerFor]="menu"
        #menuTrigger="matMenuTrigger"
        (click)="$event.stopPropagation()"
        data-cy="med_space_more_menu_btn"
      >
        <app-icon icon="ellipsis-vertical" class="cursor-pointer" />
      </mat-icon-button>
    }
  </div>

  <mat-menu #menu="matMenu">
    <div class="three_dots_menu" data-cy="med_space_more_menu">
      @if (!space.is_my_space) {
        <button
          mat-menu-item
          (click)="onOpenUpdatePrompt(space)"
          data-cy="med_rename_space_btn"
          *spaceUserCanDo="space.role; action: 'space_edit'"
        >
          <app-icon icon="pen-clip" class="icon-active" /> {{ "rename" | translate | titlecase }}
        </button>
      }
      @if (!space.is_archived && !space.is_my_space) {
        <button
          mat-menu-item
          (click)="onOpenArchivePrompt(space)"
          data-cy="med_archive_space_btn"
          *spaceUserCanDo="space.role; action: 'space_archive'"
        >
          <app-icon icon="box-archive" class="icon-active" />
          @if (!space.is_archived) {
            <span class="l-body">{{ "archive" | translate | titlecase }}</span>
          } @else {
            <span class="l-body">{{ "unarchive" | translate | titlecase }}</span>
          }
        </button>
      }
      <button
        mat-menu-item
        (click)="onCloneSpace(space)"
        data-cy="med_clone_space_btn"
        *spaceUserCanDo="space.role; action: 'space_clone'"
      >
        <app-icon icon="clone" class="icon-active" />{{ "clone" | translate | titlecase }}
      </button>
      @if (!space.is_my_space) {
        <button
          mat-menu-item
          (click)="onOpenDeletePrompt(space)"
          data-cy="med_delete_space_prompt_btn"
          *spaceUserCanDo="space.role; action: 'space_delete'"
        >
          <app-icon icon="trash-can" class="icon-active" />{{ "delete" | translate | titlecase }}
        </button>
      }
    </div>
  </mat-menu>
</div>

<ng-template #deletePrompt>
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h2 class="xs-title bold">{{ "delete_tag" | translate }}</h2>
    <button
      type="button"
      (click)="closeDialog()"
      class="bi bi-x med_close-icon btn btn-clean p-0 border-0 bg-transparent"
      aria-label="Close"
    ></button>
  </div>
  <div class="med_dialog-content vstack gap-2">
    <p class="m-body mb-2">
      {{ "delete_tag_confirmation" | translate: { tagName: selectedTagNameOriginal } }}
    </p>
    <div class="d-flex flex-column gap-2 pt-4">
      <button class="btn btn-danger w-100" (click)="onDeleteTag(); closeDialog()">
        {{ "yes_delete_tag" | translate }}
      </button>
      <button class="btn btn-link w-100" (click)="closeDialog()">
        {{ "cancel" | translate | titlecase }}
      </button>
    </div>
  </div>
</ng-template>
